<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<app-warning-label></app-warning-label>

<div class="content">
  <div
    class="scroll-wrapper ui basic segment"
    appPadding
    paddingX="0"
    [ngClass]="{ loading: pending }"
  >
    <form class="ui form">
      <div
        class="ui fluid card hoverable"
        (click)="selectDoc(doc)"
        [ngClass]="{ selected: selected == doc }"
        appMargin
        marginB="4"
        *ngFor="let doc of allTypes"
      >
        <div class="content">
          <div class="header-title">{{ doc.documentTypeName }}</div>
          <div class="header-status">
            <span
              class="ui circular label"
              style="background: #f3f4f6; color: #1f2937"
              *ngIf="doc.isRequired"
            >
              Mandatory
            </span>
          </div>
        </div>
      </div>
      <app-no-record-found
        *ngIf="allTypes && allTypes.length < 1"
      ></app-no-record-found>
    </form>
  </div>

  <div class="actions" style="background: none; border: none">
    <button class="ui basic primary button" (click)="modal.deny(undefined)">
      Cancel
    </button>
    <button
      class="ui primary button"
      appMargin
      marginL="5px"
      [ngClass]="{ yellow: pending }"
      [disabled]="pending || !selected"
      (click)="modal.approve(selected)"
      autofocus
    >
      Next
    </button>
  </div>
</div>
